import { OfferCardProps } from '@cash-rewards/cr-ui-components';

export const OFFER_BADGE_MAP: Record<string, OfferCardProps['badgeType']> = {
  NewStore: 'NEW_STORE',
  DoubleCashback: 'DOUBLE_CASHBACK',
  TripleCashback: 'TRIPLE_CASHBACK',
  QuadrupleCashback: 'QUADRUPLE_CASHBACK',
  Exclusive: 'EXCLUSIVE',
  EndDateCount: 'END_DATE_COUNT',
  GiftCard: 'GIFT_CARD',
  FlashSale: 'FLASH_SALE',
};
